import Link from 'next/link';
import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { PhotoSwipe } from 'react-photoswipe';
import API from '../../config/config';

const ProductFeatureContent = (props: any) => {

  const [state, setstate] = useState({
    isOpen: false
  });

  const items = [
    {
      src:
        API.baseUrl + props.data.SizeComparisonLink.sizeComparisonImage?.url,
      w: 500,
      h: 200
    }
  ];

  const Pophandle = () => {
    setstate({
      isOpen: !state.isOpen
    });
  };
  const windowSize = useWindowSize();
  function useWindowSize() {
    const [dimension, setDimensions] = useState({
      height: undefined,
      width: undefined
    });
    useEffect(() => {
      const handleResize = () => {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        });
      };

      window.addEventListener('resize', handleResize);
      handleResize()
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);
    return dimension
  }


  return (
    <React.Fragment>
      <div className={windowSize.width >= 768 ? 'show' : 'hide'}>
        <div className=" productFeatureContent-background" style={{ backgroundImage: 'url(' + API.baseUrl + props.data.backgroundImage.url + ')' }}>
          <div className="container-fluid  ">
            <div className="container">
              <Row xl={2} md={2} sm={1} xs={1}>
                <Col>
                  <div className="productFeatureContent-flex-container">
                    <div>
                      <h2 className="productFeatureContent-h2">{props.data.title}</h2>
                    </div>
                    <div>
                      <h6 className="productFeatureContent-h6">
                        {props.data.subTitle}
                      </h6>
                    </div>
                    <div>
                      <h6 className="productFeatureContent-h6-hyperlink">
                        <span onClick={Pophandle}>{props.data.SizeComparisonLink.label}</span>
                      </h6>
                    </div>
                    <div>
                      <h6 className="productFeatureContent-button">
                        <Link href={props.data.ShopNowButton.url}>
                          <a>{props.data.ShopNowButton.text}</a>
                        </Link>
                      </h6>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <PhotoSwipe isOpen={state.isOpen} items={items} onClose={Pophandle} />
      <div className={windowSize.width < 768 ? 'show' : 'hide'}>
        <div className=" productFeatureContent-background">
          <div className="container-fluid  ">
            <div className="container">
              <Row xl={2} md={1} sm={1} xs={1}>
                <Col>
                  <div className="productFeatureContent-flex-container">
                    <div>
                      <h2 className="productFeatureContent-h2">{props.data.title}</h2>
                    </div>
                  </div>
                </Col>
                <div>
                  <img
                    src={API.baseUrl + props.data.mobileBackgroundImage.url}
                    alt="background"
                    className="productFeatureContent-img"
                  />
                </div>
                <Col>
                  <div className="productFeatureContent-flex-container">
                    <div>
                      <h6 className="productFeatureContent-h6">
                        {props.data.subTitle}
                      </h6>
                    </div>
                    <div>
                      <h6 className="productFeatureContent-h6-hyperlink">
                        <span onClick={Pophandle}>
                          {props.data.SizeComparisonLink.label}
                        </span>
                      </h6>
                    </div>
                    <div>
                      <h6 className="productFeatureContent-button">
                        <Link href={props.data.ShopNowButton.url}>
                          <a>{props.data.ShopNowButton.text}</a>
                        </Link>
                      </h6>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProductFeatureContent;
